module.exports = __webpack_public_path__ + "media/packs/images/eye-21dcb9221b40feea73aa3ae0bab5e0cb.svg";